import React from 'react';
import { Users } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { UserTable } from './UsersTable';
import { PageLayout } from '~/shared/PageLayout';

export const UserLibrarySection = {
	settingsView: 'users',
	title: 'Users',
	description: 'Manage user directory',
	TitleIcon: Users
} satisfies SettingsSectionItem;

export function UserLibrary() {
	return (
		<PageLayout
			pageHeader={{
				title: UserLibrarySection.title,
				description: UserLibrarySection.description,
				TitleIcon: UserLibrarySection.TitleIcon
			}}
		>
			<LibrarySection
				librarySection={UserLibrarySection}
				searchPlaceholder="Search user by name, or email address..."
				noResultsLabel="No Users Found"
				noResultsSubLabel="Get started by adding your first user"
				TableComponent={UserTable}
			/>
		</PageLayout>
	);
}
